import { Euro, ReceiptText, Wallet } from "lucide-react";

import { BarChartCard } from "./BarChartCard";
import { formatCurrency } from "./chartPalette";
import { DonutChartCard } from "./DonutChartCard";
import { ChartsGrid, InsightsPanel, StatsRow } from "./InsightsLayout";
import { StatCard } from "./StatCard";
import { TrendChartCard } from "./TrendChartCard";

export const AccountingInsights = ({ insights, isLoading }) => {
  const totalOutstanding = insights?.totalOutstanding ?? 0;

  return (
    <InsightsPanel>
      <StatsRow>
        <StatCard label="Total Billed" icon={Euro} isLoading={isLoading}
          value={formatCurrency(insights?.totalBilled)} />
        <StatCard label="Total Paid" icon={ReceiptText} tone="success" isLoading={isLoading}
          value={formatCurrency(insights?.totalPaid)} />
        <StatCard label="Outstanding" icon={Wallet} tone={totalOutstanding > 0 ? "warning" : "neutral"} isLoading={isLoading}
          value={formatCurrency(totalOutstanding)} />
      </StatsRow>
      <ChartsGrid>
        <BarChartCard title="Revenue by Service" data={insights?.byService} dataKey="amount"
          valueFormatter={formatCurrency} isLoading={isLoading} />
        <DonutChartCard title="By Payment Status" data={insights?.byPaymentStatus} isLoading={isLoading} />
        <TrendChartCard title="Revenue Over Time" data={insights?.trendByDay} dataKey="amount"
          valueFormatter={formatCurrency} isLoading={isLoading} />
      </ChartsGrid>
    </InsightsPanel>
  );
};
